import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import './LandingStatistics.css'
import users from '../../Assets/images/users.png'
import cart from '../../Assets/images/cart.png'
import education from '../../Assets/images/education.png'
import article from '../../Assets/images/article.png'
import LandingCounter from '../LandingCounter/LandingCounter'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
export default function LandingStatistics() {
    const [countList,setCountList]=useState({
        userCount:0,
        blogCount:0,
        courseCount:0,
        productCount:0,
    });
    useEffect(() => {
        axiosConfig.get("api/home").then((res)=>{
            setCountList(res.data);
        });
    }, [])
    return (
        <div className='landing-statistics'>
            <div className='landing-statistics-item'>
                <div className='landing-statistics-image'>
                    <img src={users} alt="تعداد کاربران" />
                </div>
                <div className='landing-statistics-title'>
                    <LandingCounter count={countList?.userCount} />  کاربر
                </div>

            </div>


            <div className='landing-statistics-item'>
                <div className='landing-statistics-image'>
                    <img src={article} alt="تعداد مقالات" />
                </div>
                <div className='landing-statistics-title'>
                    <LandingCounter count={countList.blogCount} /> مقاله
                </div>

            </div>


            <div className='landing-statistics-item'>
                <div className='landing-statistics-image'>
                    <img src={education} alt="تعداد دوره ها" />
                </div>
                <div className='landing-statistics-title'>
                    <LandingCounter count={countList.courseCount} /> دوره
                </div>

            </div>
            <div className='landing-statistics-item'>
                <div className='landing-statistics-image'>
                    <img src={cart} alt="تعداد محصول ها" />
                </div>
                <div className='landing-statistics-title'>
                    <LandingCounter count={countList.productCount} /> محصول
                </div>

            </div>
        </div>
    )
}
